import { EndLayer } from "./EndLayer";
import { TutorialLayer } from "./TutorialLayer";
import { GameVars } from "../../GameVars";
import { BoardContainer } from "./board-container/BoardContainer";
import { BoardManager } from "./BoardManager";
import { GUI } from "./gui/GUI";
import { AudioManager } from "../../AudioManager";
import { PauseLayer } from "./PauseLayer";
import { GiveUpLayer } from "./GiveUpLayer";

export class BoardScene extends Phaser.Scene {

    public static currentInstance: BoardScene;

    private boardContainer: BoardContainer;
    private gui: GUI;
    private pauseLayer: PauseLayer;
    private giveUpLayer: GiveUpLayer;
    private tutorialLayer: TutorialLayer;
    private endLayer: EndLayer;
    
    constructor() {

        super("BoardScene");
        
        BoardScene.currentInstance = this;

        BoardManager.init();
    }

    public create(): void {

        GameVars.currentScene = this;

        this.boardContainer = new BoardContainer(this);
        this.add.existing(this.boardContainer);

        this.gui = new GUI(this);
        this.add.existing(this.gui);

        this.pauseLayer = new PauseLayer(this);
        this.add.existing(this.pauseLayer);

        this.giveUpLayer = new GiveUpLayer(this);
        this.add.existing(this.giveUpLayer);

        this.resume();

        BoardManager.startGame(GameVars.difficulty);

        AudioManager.playMusic("soundtrack", .6);

    }

    public update(): void {
        
        this.boardContainer.update();
    }

    public startGame(): void {
        
        this.gui.startGame();
        this.boardContainer.startGame();
    }

    public showPauseLayer(): void {

        this.pauseLayer.visible = true;
        this.pause();
    }

    public hidePauseLayer(): void {

        this.pauseLayer.visible = false;
        this.resume();
    }

    public showGiveUpLayer(): void {

        this.giveUpLayer.visible = true;
        this.pause();
    }

    public hideGiveUpLayer(): void {

        this.giveUpLayer.visible = false;
        this.resume();
        
    }

    public pause(): void {

        GameVars.currentScene.tweens.pauseAll();
        GameVars.currentScene.time.paused = true;
    }
    
    public resume(): void {

        GameVars.currentScene.tweens.resumeAll();
        GameVars.currentScene.time.paused = false;
    }

    public showTutorial(type: string): void {

        if (GameVars.gameOver) {
            return;
        }

        this.tutorialLayer = new TutorialLayer(this, type);
        this.add.existing(this.tutorialLayer);
    }

    public removeTutorial(): void {

        this.tutorialLayer.destroy();
    }

    public endGame(type: string): void {

        if (this.endLayer) {
            return;
        }

        GameVars.gameOver = true;

        this.endLayer = new EndLayer(this, type);
        this.add.existing(this.endLayer);
    }

    public removeEndScene(): void {
        
        this.endLayer = null;
    }
}
